/**
 * @author Ariel
 * @Date 2021/6/2
 */
import React from 'react';
import {framework_tool, component_tool, utils_tool} from '@/tool'
import moment from "moment";
import {connect} from "dva";

let {WizContainer,modelUtils} = framework_tool
let {WizComponent, WizForm, WizSpin, WizRow, WizCol, WizRadio} = component_tool;
let {Session} = utils_tool

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const _getValue = (type, key) => {
  const values = {
    type: {
      0: "公共",
      1: "班级",
      // 2: "活动"
    },
    state: {
      0: '无效',
      1: '有效'
    }
  };
  return values[type][key]
}

class ApplyPlanCol extends WizContainer {
  constructor(props) {
    super(props);
    this.state = {}
  }

  propsAndStateOnChange = {
    addPlan: this._addPlanData.bind(this),
    updatePlan: this._updatePlanData.bind(this)
  }

  _addPlanData(nextProps, nextState) {
    let { addPlan, changeModal } = nextProps
    if (addPlan && addPlan.code == 1) {
      if (addPlan.success) {
        wizNotice.success(nextProps.addPlan.msg)
        changeModal(false, true, true)
      }
    } else {
      wizNotice.error('新增计划安排失败：' + nextProps.addPlan.msg);
      return false;
    }
    return true;
  }

  _updatePlanData(nextProps, nextState) {
    let { updatePlan, changeModal } = nextProps
    if (updatePlan && updatePlan.code == 1) {
      if (updatePlan.success) {
        wizNotice.success(nextProps.updatePlan.msg)
        changeModal(false, true, true)
      }
    } else {
      wizNotice.error('编辑计划安排失败：' + nextProps.updatePlan.msg);
      return false;
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'applyPlanTime' && value != null && value != undefined) {
        fitterValues['startTime'] = moment(value[0]).format("YYYY-MM-DD HH:mm:00")
        fitterValues['endTime'] = moment(value[1]).format("YYYY-MM-DD HH:mm:59")
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  /**
   * @param this.initialValue
   * @private
   */
  _savePlan(value) {
    let apiPath = "applyPlan/addPlan";
    let {record} = this.props
    if (record && record.id) {
      apiPath = "applyPlan/updatePlan"
    }
    let fitterValues = this.fitterFieldsValue(value)
     this.doAction({
        path: apiPath,
        payload: {
          key: "addPlan",
          apiParams: {...fitterValues}
        }
      })
  }

  render() {
    const {record = {}, applyId,type} = this.props;
    let disable = false
    let maxVar = 999999999
    let minVar = -1
    if (type === 1) {
      let applyNumber = -1
      let {classLimitNum,reviewNumber,passNumber} = record
      disable = true
      maxVar = classLimitNum
      reviewNumber == -1 ? 0 : reviewNumber
      passNumber == -1 ? 0 : passNumber
      applyNumber = reviewNumber + passNumber
      if (applyNumber > 0) {
        minVar = applyNumber
      }
    }
    let columns = [
      {
        name: "id",
        formItem: {
          type: "hidden",
          initialValue: record && record.id
        }
      },
      {
        name: "type",
        formItem: {
          type: "hidden",
          initialValue: type
        }
      },
      {
        name: "applyId",
        formItem: {
          type: "hidden",
          initialValue: applyId
        }
      },
      {
        title: '计划安排名称',
        name: "name",
        formItem: {
          maxLength: 30,
          message: "计划安排名称不能超过30个字符",
          rules: [
            {
              required: true,
              message: "计划安排名称必填"
            },
          ],
          initialValue: record && record.name,
          disabled: disable
        }
      },
      {
        title: "计划安排时间",
        key: "applyPlanTime",
        name: "applyPlanTime",
        formItem: {
          type: "date~",
          rules: [
            {
              required: true,
              message: "时间必填"
            }
          ],
          showTime: {format: 'HH:mm'},
          format: 'YYYY-MM-DD HH:mm',
          initialValue: record && record.startTime && [moment(record.startTime), moment(record.endTime)],
          disabled: disable
        },
      },
      {
        title: "地址",
        dataIndex: "address",
        key: "address",
        name: "address",
        formItem: {
          ellipsis: true,
          // maxLength: 200,
          rules: [
            {
              required: !disable,
              message: "地址必填"
            }
          ],
          initialValue: record && record.address ? record.address : " ",
          disabled: disable
        },
      },
      {
        title: "限制人数",
        dataIndex: "limitCount",
        key: "limitCount",
        name: "limitCount",
        formItem: {
          type: 'number',
          placeholder: '-1表示不限制',
          min: minVar,
          max: maxVar,
          rules: [
            {
              required: true,
              message: "限制人数必填,-1表示不限制"
            }
          ],
          initialValue: record && record.limitCount > maxVar ? maxVar : record.limitCount
        },
      },
      {
        title: "安排状态",
        dataIndex: "state",
        key: "state",
        name: "state",
        dict: [
          { code: 1, codeName: '有效' },
          { code: 0, codeName: '无效' },
        ],
        formItem: {
          type: 'radio',
          initialValue: record && record.state ? record.state : 1
        }
      },
    ]

    let onSubmit = this._savePlan.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }

    return (
      <>
        <WizForm className={'form-inline'} {...formProps} />
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {applyPlan} = state
  const addPlan = modelUtils.getModelEntity(applyPlan, 'addPlan');
  const updatePlan = modelUtils.getModelEntity(applyPlan, 'updatePlan');
  return {
    addPlan,
    updatePlan
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(ApplyPlanCol);
